import {
  loadDemoInput,
  clearDemoInput,
} from "../components/skill_sheet_main/utils/demoStorage";
import { buildDemoFormData } from "../components/skill_sheet_main/utils/demoSignupPayload";

// デモ入力の本登録引き継ぎ
// - 本登録ページ（/users/sign_up?from=demo）: localStorage のデモ入力をフォームに載せる
// - 引き継ぎ後のログイン画面: localStorage のデモ入力を消す
// - 削除するかは URL クエリではなく <body data-demo-transferred> で判定する。

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.dataset.demoTransferred === "true") {
    clearDemoInput();
  } else {
    attachDemoInputToForm();
  }
});

// 本登録フォームに、localStorage のデモ入力を hidden field として付ける
function attachDemoInputToForm() {
  const form = document.getElementById("user-form");
  if (!form) return;

  // from=demo は Rails 側が hidden で描画する（初回も、登録失敗の再表示も）
  const isDemoSignup = form.querySelector('input[name="from"][value="demo"]');
  if (!isDemoSignup) return;

  const { values, failed } = loadDemoInput();
  // 引き継げるデモ入力が無い / 壊れている → 通常の新規登録として扱う
  if (failed || !values) return;

  let demoFormData;
  try {
    demoFormData = buildDemoFormData(values);
  } catch {
    // 型が壊れていて変換できない場合も通常の新規登録として扱う
    return;
  }

  const hidden = document.createElement("input");
  hidden.type = "hidden";
  hidden.name = "demo_form_data";
  hidden.value = demoFormData;
  form.appendChild(hidden);
}
